// src/pages/NewsDetail/NewsDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { profileService } from '../../services/profileService';
import './NewsDetail.css';

const NewsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await profileService.getNewsDetail(slug);
        console.log("DEBUG - News detail data:", data);
        setArticle(data);
      } catch (err) {
        setError(err.message || 'Failed to load news article');
        console.error('Error fetching news detail:', err);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchNewsDetail();
    }
  }, [slug]);

  const formatTimeAgo = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return date.toLocaleDateString();
  };

  if (loading) {
    return (
      <div className="news-detail-page">
        <div className="loading-state">Loading article...</div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="news-detail-page">
        <div className="error-state">
          <p>{error || 'Article not found'}</p>
          <button className="back-button" onClick={() => navigate(-1)}>Go Back</button>
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-page">
      <div className="news-detail-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back to Profile
        </button>
        
        {article.category_name && (
          <div className="news-category-badge">
            {article.category_name}
          </div>
        )}

        <h1 className="news-detail-title">{article.title}</h1>
        
        <div className="news-meta">
          <span className="news-meta-item">
            📅 {formatTimeAgo(article.published_at || article.created_at)}
          </span>
          <span className="news-meta-item">
            👁 {article.views || 0} views
          </span>
          <span className="news-meta-item">
            🕐 {article.read_time || 3} min read
          </span>
        </div>

        <div className="news-content">
          {article.content ? (
            <div dangerouslySetInnerHTML={{ __html: article.content.replace(/\n/g, '<br/><br/>') }} />
          ) : article.summary ? (
            <p>{article.summary}</p>
          ) : (
            <p>No content available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;